export default "__VITE_ASSET__7605fe02__"